export const getDocReferrer = (): string => {
  const referrer: string | undefined = document?.referrer;
  // const clientConfig = getClientConfig();
  // const isDevelopment = clientConfig?.nodeEnv === 'development';
  const isDevelopment = /localhost(:\d+)?/.test(location.origin);

  if (isDevelopment) {
    return window.location.origin;
  }

  // Allow all axa.com.hk and *.axa.com.hk domains
  const axaDomainPattern = /^https?:\/\/([\w-]+\.)*axa\.com\.hk(\/.*)?$/;

  if (axaDomainPattern.test(referrer)) {
    return referrer;
  } else {
    throw new Error(`The document.referrer ${referrer} is not whitelisted.`);
  }
};
